import React from 'react';
import { WarningDialog } from '../Dialog/WarningDialog';

export const AppPenalty = ({ penalty, setPenalty, kbSubdomain, logout }) => {
    if (!penalty) return null;

    const entity = kbSubdomain ? 'Application' : 'Account';
    let title, content, buttonName, onClose;

    const termsLink = <a href="https://openkbs.com/terms-of-use/" target="_blank" rel="noopener noreferrer">terms of service</a>;

    switch (penalty.level) {
        case 1:
            title = 'Warning Issued';
            content = (
                <>
                    <p>Your {entity} has been issued a warning.</p>
                    <p>Reason: "{penalty.reason}"</p>
                    <p>Details: "{penalty.details}"</p>
                    <p>Please adhere to our {termsLink} to avoid further penalties.</p>
                </>
            );
            buttonName = 'Acknowledge';
            onClose = () => {
                setPenalty(null)
                localStorage.setItem('AcknowledgeWarning', penalty.createdAt)
            };
            break;

        case 2:
            title = `${entity} Suspended`;
            content = (
                <>
                    <p>Your {entity} has been temporarily suspended.</p>
                    <p>Reason: "{penalty.reason}"</p>
                    <p>Details: "{penalty.details}"</p>
                    <p>Please review our {termsLink}. You will regain access after the suspension period.</p>
                </>
            );
            buttonName = 'Close';
            onClose = null;
            break;

        case 3:
            title = `${entity} Banned`;
            content = (
                <>
                    <p>Your {entity} has been banned.</p>
                    <p>Reason: "{penalty.reason}"</p>
                    <p>Details: "{penalty.details}"</p>
                    <p>Please contact support if you believe this is a mistake.</p>
                </>
            );
            buttonName = 'Close';
            onClose = null;
            break;

        default:
            title = penalty.reason;
            content = <p>{penalty.details}</p>;
            buttonName = 'Close';
            onClose = null;
    }

    return (
        <WarningDialog
            title={title}
            content={content}
            buttonName={buttonName}
            logout={logout}
            onClose={onClose}
        />
    );
};